import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { cartSelectors } from '../../../../pages/Cart/cartSlice'
import { userSelectors } from '../../../../redux/userSlice'
import { AccountTypes, CourseTypes } from '../../../../util/constants'
import { getFreeCoursesLeft } from '../../../../util/functions'
import { ReactComponent as HeartIcon } from '../../../../assets/icons/heart.svg'
import { ReactComponent as HeartFilledIcon } from '../../../../assets/images/heart-filled.svg'
import { ReactComponent as RightIcon } from '../../../../assets/icons/arrow-right.svg'
import { Button, ButtonIcon } from '../../../Button/Button'
import classes from './cardTooltip.module.css'

export const CardTooltip = ({
    title,
    category,
    students,
    lectures,
    downloads,
    description,
    className = '',
    addToCart,
    addingToCart,
    addToWishlist,
    itemInWishlist,
    addToCartCustomText,
    courseType,
    benefits,
    hideFavorite,
}) => {
    const items = useSelector(cartSelectors.cartItems)
    const user = useSelector(userSelectors.userDetails)
    const subscribedUser =
        String(user.accounttype).toLowerCase() ===
        AccountTypes.Subscriber?.toLowerCase()
    const userFreeCourses = getFreeCoursesLeft({
        items,
        freeCourses: user.freeCourses,
    })
    let hasFree = false
    if (
        subscribedUser &&
        userFreeCourses > 0 &&
        courseType === CourseTypes.Free_For_Subscribers
    ) {
        hasFree = true
    }

    return (
        <div className={classNames(classes.cardTooltip, className)}>
            <h4 className={classes.cardTooltipTitle}>{title}</h4>
            <p className={classes.cardTooltipCategory}>{category}</p>
            <div className={classes.cardTooltipDetails}>
                {benefits ? (
                    benefits?.map((benefit, index) => (
                        <p key={index} className={classes.cardTooltipDetail}>
                            <span>{benefit}</span>
                        </p>
                    ))
                ) : (
                    <>
                        <p className={classes.cardTooltipDetail}>
                            <span>{lectures} lectures</span>
                        </p>
                        <p className={classes.cardTooltipDetail}>
                            <span>{students} students</span>
                        </p>
                        <p className={classes.cardTooltipDetail}>
                            <span>{downloads} downloads</span>
                        </p>
                    </>
                )}
            </div>
            <p className={classes.cardTooltipDescription}>{description}</p>
            <div className={classes.cardTooltipButtons}>
                <Button
                    bold={false}
                    onClick={() => addToCart(hasFree)}
                    disabled={addingToCart}
                    style={{ fontSize: 14 }}
                >
                    {addToCartCustomText ||
                        (hasFree ? 'Get For Free' : 'Add to Cart')}
                    <ButtonIcon icon={<RightIcon />} />
                </Button>
                {!hideFavorite && (
                    <Button
                        iconOnly={'true'}
                        label={'Add to wishlist'}
                        onClick={addToWishlist}
                    >
                        <ButtonIcon
                            icon={
                                itemInWishlist ? (
                                    <HeartFilledIcon />
                                ) : (
                                    <HeartIcon />
                                )
                            }
                        />
                    </Button>
                )}
            </div>
        </div>
    )
}
